/**
 * Temperature Conversion Tool - Smooth scroll to result after conversion
 * @module TemperatureConversion
 */
(function() {
    'use strict';

    /**
     * Initialize the temperature conversion tool
     */
    function init() {
        scrollToResult();
    }

    /**
     * Scroll to conversion result if it exists
     */
    function scrollToResult() {
        var resultElement = document.getElementById('conversion-result');
        if (resultElement && typeof resultElement.scrollIntoView === 'function') {
            window.requestAnimationFrame(function() {
                resultElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Expose public API
    window.TemperatureConversion = {
        scrollToResult: scrollToResult
    };
})();
